// export function client() {
//   var client = new OSS({
//     region:  process.env.VUE_APP_REGION,
//     accessKeyId: 'LTAI4G2Ny6D8R6Np2FzuQ67W',
//     accessKeySecret:'3tOZbidBzlo9EqxSozEtdqHLQiI2y0',
//     bucket: process.env.VUE_APP_OSSBUKET
//   })  
//   return client
// }

export function client() {
  var client = new OSS({
    region:  sessionStorage.getItem("OssConfig") ? JSON.parse(sessionStorage.getItem("OssConfig")).region : '',
    accessKeyId: sessionStorage.getItem("OssConfig") ? JSON.parse(sessionStorage.getItem("OssConfig")).accessKeyId : '',
    accessKeySecret: sessionStorage.getItem("OssConfig") ? JSON.parse(sessionStorage.getItem("OssConfig")).accessKeySecret : '',
    bucket: sessionStorage.getItem("OssConfig") ? JSON.parse(sessionStorage.getItem("OssConfig")).bucket : '',
	  stsToken: sessionStorage.getItem("OssConfig") ? JSON.parse(sessionStorage.getItem("OssConfig")).stsToken : '',
  })  
  return client
}